module.exports = __webpack_public_path__ + "static/media/image2.e3b42570.jpg";